import { observable } from 'mobx';
import { Session } from './sessions/Session';
import { UserNotification } from '@foxbun/lib-goferal-types';

export interface UserNotificationEngineOptions {
  session: Session;
}

export class UserNotificationEngine {
  @observable
  accessor notifications: UserNotification[];

  @observable
  accessor loading: boolean;

  constructor(protected options: UserNotificationEngineOptions) {
    this.notifications = [];
    this.loading = false;
    options.session.registerListener({
      activate: () => {
        this.loadNotifications();
      }
    });
  }

  async loadNotifications() {
    this.loading = true;
    try {
      this.notifications = await this.options.session.api_client.profile.notifications();
    } finally {
      this.loading = false;
    }
  }
}
